// === PERSONENAUTO — selected hoofddekking highlights ===
// Tinted "this is covered" block under the hoofddekking cards: the auto counterpart of the
// base-coverage box on the other products. Bullets come from the comparison-matrix rows, plus
// the eigen-risico line as the closing bullet (like Woonhuis' storm deductible).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { commonStyles, personenAutoStyles } from '../../../styles/commonStyles';
import { CheckBulletList } from '../../../components/CheckBulletList';
import { AUTO_VARIANT_COLUMN, coveredMatrixKeys, type AutoVariant } from './coverages';

export const CoverageHighlights: React.FC<{ selectedHoofd: AutoVariant }> = ({ selectedHoofd }) => {
  const { t } = useTranslation();
  const items = [
    ...coveredMatrixKeys(selectedHoofd).map((key) => t(`screens.personenauto.coverageMatrix.rows.${key}`)),
    t('screens.personenauto.coverage.deductibleNote'),
  ];
  return (
    <div style={{ ...commonStyles.baseCoverageBox, ...personenAutoStyles.coverageNoticeMt }}>
      <div style={commonStyles.rowBetweenFull}>
        <label style={commonStyles.baseCoverageTitle}>
          {t(`screens.personenauto.coverage.${AUTO_VARIANT_COLUMN[selectedHoofd]}`)}
        </label>
      </div>
      <CheckBulletList items={items} variant="emphasis" />
    </div>
  );
};

export default CoverageHighlights;
